import { makeStyles } from '@material-ui/core'
import {
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS
} from 'asterX-UIkit'

export const useChatMessageStyles = makeStyles(theme => ({
  messageAuthor: {
    fontSize: 14,
    color: GRAY_COLORS[700],
    fontWeight: 500
  },
  messageTime: {
    fontSize: 14,
    color: GRAY_COLORS[600],
    fontWeight: 400,
    marginLeft: 15
  },
  messageText: {
    fontSize: 16,
    fontWeight: 400,
    wordBreak: 'break-word',
    margin: 0
  },
  primaryBackground: {
    color: '#fff',
    backgroundColor: PRIMARY_COLORS[600],
    padding: '10px 14px',
    borderRadius: '8px 0px 8px 8px',
    marginBottom: 3
  },
  secondaryBackground: {
    color: '#000',
    backgroundColor: GRAY_COLORS[200],
    padding: '10px 14px',
    borderRadius: '0 8px 8px 8px'
  },
  errorBackground: {
    color: '#fff',
    backgroundColor: ERROR_COLORS[500],
    padding: '10px 14px',
    borderRadius: '0 8px 8px 8px'
  },
  completeBackground: {
    color: '#fff',
    backgroundColor: SUCCESS_COLORS[500],
    padding: '10px 14px',
    borderRadius: '0 8px 8px 8px'
  },
  iconButton: {
    width: 'fit-content',
    borderRadius: 50,
    backgroundColor: GRAY_COLORS[100],
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  fileBackground: {
    backgroundColor: '#fff',
    padding: '10px 14px',
    borderRadius: '8px 0px 8px 8px',
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  originalFileName: {
    fontSize: 14,
    color: GRAY_COLORS[700],
    fontWeight: 500,
    wordBreak: 'break-word',
    margin: 0
  },
  size: {
    fontSize: 14,
    color: GRAY_COLORS[600],
    fontWeight: 400,
    wordBreak: 'break-word',
    margin: 0
  },
  errorTitle: {
    fontSize: 16,
    fontWeight: 600,
    margin: 0
  },
  completeContainer: {
    color: GRAY_COLORS[700],
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 8,
    padding: 6,
    marginBottom: 8
  },
  completeButton: {
    marginTop: 5,
    height: 45,
    '&:hover': {
      backgroundColor: PRIMARY_COLORS[25]
    }
  }
}))
